export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.c152b21e.woff2";